import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton } from '@mui/material'
import {
  ProgressionFilters,
  MuiTextField,
  MuiImage,
  Confirmation,
  LoaderWrapper,
  MuiMultiSelect,
} from '../../../../components'
import reportsService from '../../../../services/reports.service'
import { IconEdit, IconDelete, IconArrowSort, closeMini, IconSortUpDownArrow, IconSortDownUpArrow, IconSearchbar } from '../../../../assets/images/icons'
import { useGlobalStore } from '../../../../store'
import {
  removeHtmlTags,
  removeUnwantedTagsAndAttributes,
  rteRemovingStyleFromTable,
} from '../../../../util'
import { TableContainerWrapper, ProgressionWrapper } from './style'

const GridTable = ({
  insightsElementId,
  showAdminButtons,
  rowTableData,
  data,
  settings,
  sortGridBy,
  onSearchChange,
  onCheckBoxChange,
  onSortByChange,
  editClicked,
  onDeleteClicked,
}) => {
  const [searchInput, setSearchInput] = useState('')
  const [columnCheckboxObj, setColumnCheckboxObj] = useState()
  const [rowCheckboxObj, setRowCheckboxObj] = useState()
  const [deleteBox, setDeleteBox] = useState({ show: false, data: null })
  const { isPPTModalActive } = useGlobalStore()

  const searchChangeFunc = (value) => {
    setSearchInput(value)
    onSearchChange(value)
  }

  const [accordionHeading, setAccordionHeading] = useState([
    { field: 'Row', sortKey: 'rows', data: [settings.rows], filterIndex: [] },
    { field: 'Column', sortKey: 'columns', data: [settings.columns], filterIndex: [] },
  ])

  const stripHtml = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
  };

  // const getTitlesFunc = (obj, type) => {
  //   if (type === 'column') {
  //     return Object.keys(obj)
  //       .filter((t) => t !== 'topic')
  //       .filter((s) => obj[s].customColumnFilterBy)
  //       .map((k) => obj[k].title)
  //     // return Object.keys(obj).filter(t => t !== 'topic').map(k => (obj[k].title))
  //   } else if (type === 'row') {
  //     return Object.keys(obj).map((k) => obj[k].title)
  //   }
  // }

  const filterChangeFunc = (index, filterKey, selectedValuesRaw) => {
    const selectedValues = selectedValuesRaw.filter((val) => val !== 'All');

    const updatedColumns = { ...settings.columns };
    const updatedRows = { ...settings.rows };

    if (filterKey === 'columns') {
      Object.keys(updatedColumns).forEach((key) => {
        if (key !== 'topic') {
          if (!updatedColumns[key].customColumnFilterBy) {
            updatedColumns[key].show = true;
          } else {
            updatedColumns[key].show = selectedValues.includes(updatedColumns[key].title);
          }
        }
      });
    }

    if (filterKey === 'rows') {
      Object.keys(updatedRows).forEach((key) => {
        if (key !== 'topic') {
          updatedRows[key].show = selectedValues.includes(stripHtml(updatedRows[key].title));
        }
      });
    }

    const updatedAccordionHeading = [...accordionHeading];
    updatedAccordionHeading[index] = {
      ...updatedAccordionHeading[index],
      filterIndex: selectedValues,
    };

    setColumnCheckboxObj(updatedColumns);
    setRowCheckboxObj(updatedRows);
    onCheckBoxChange('row', updatedRows);
    onCheckBoxChange('column', updatedColumns);
    setAccordionHeading(updatedAccordionHeading);
  };
  
  // const checkboxChangeFunc = (type, key) => {
  //     if(type === 'column'){
  //         settings.columns[key].show = !settings.columns[key].show
  //         onCheckBoxChange(type, settings.columns)
  //         setColumnCheckboxObj(settings.columns)
  //     }
  //     else if(type === 'row'){
  //         settings.rows[key].show = !settings.rows[key].show
  //         onCheckBoxChange(type, settings.rows)
  //         setRowCheckboxObj(settings.rows)
  //     }
  // }

  const onCloseBox = () => {
    setDeleteBox({ ...deleteBox, show: false })
  }
  const onSubmitBox = (param) => {
    setDeleteBox({ ...deleteBox, show: false })
    const deleteObj = rowTableData
      .filter((r) => r.CustomRowId === deleteBox.data.rowId)
      .map((d) => ({
        CustomRowColumn: {
          InsightsElementId: insightsElementId,
          CustomRowId: d.CustomRowId,
          CustomColumnId: d.CustomColumnId,
          // CustomColumnValue: d.CustomColumnValue
          CustomColumnValue: d.CustomColumnValue
            ? encodeURIComponent(rteRemovingStyleFromTable(d.CustomColumnValue))
            : null, // Hindi conversion
        },
      }))
    const finalDeleteObject = {
      customRowColumns: deleteObj,
      delete: true,
    }

    reportsService
      .reportSetCustomTableRowApi(finalDeleteObject)
      .then((resp) => {
        onDeleteClicked()
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        // setSubTabsLoading(false)
      })
  }

  useEffect(() => {
    setColumnCheckboxObj(settings.columns)
    setRowCheckboxObj(settings.rows)
  }, [settings])

  useEffect(() => {
    if (data?.length > 0) {
      const keys = Object.keys(settings.columns)
      const finalObj = {}
      for (let i = 0; i < keys.length; i++) {
        if (settings.columns[keys[i]].customColumnDefaultSortBy) {
          finalObj.key = keys[i]
          finalObj.obj = settings.columns[keys[i]]
          break
        }
      }
      if (finalObj?.key) {
        onSortByChange(finalObj?.key, finalObj.obj.customColumnDefaultSortOrder === 'ASC')
      }
    }
    // if(data?.[0]?.topic){
    //     const isNumber = removeHtmlTags(data[0].topic, 'removePercent')
    //     if(isNumber > 0) { onSortByChange('topic') }
    // }
  }, [])

  return (
    <>
      <ProgressionWrapper className='progressionWrapper'>
        <MuiTextField
          placeholder='Enter keywords...'
          name='search'
          onChange={(e) => searchChangeFunc(e.target.value)}
          type='text'
          value={searchInput}
          variant='outlined'
          className='searchBox'
          styletype='themeV2'
          InputProps={{
            startAdornment: <IconSearchbar />,
          }}
        />
        {/* {searchInput.length > 1 && <IconButton className='clearSearchBox' onClick={() => searchChangeFunc('')}><MuiImage src={closeMini} /></IconButton>} */}
        {/* // <ProgressionFilters
        //   showSearch={true}
        //   data={{
        //     drivers: getTitlesFunc(columnCheckboxObj, 'column'),
        //     periods: getTitlesFunc(rowCheckboxObj, 'row'),
        //   }}
        //   titles={{ drivers: settings.tabColumnTitle, periods: settings.tabRowTitle }}
        //   onChange={filterChangeFunc}
        // />
         */}
        {columnCheckboxObj && rowCheckboxObj && accordionHeading?.map((e, index) => {
          const filterKey = e.sortKey;
          const fieldType = e.field;

          const dataList = e.data?.[0]
            ? Object.values(e.data[0]).map((item) =>
              fieldType === 'Row' ? stripHtml(item.title) : item.title
            )
            : [];

          return (
            <MuiMultiSelect
              key={index}
              name={filterKey}
              placeholder={`Select ${fieldType}`}
              onChange={(val) => filterChangeFunc(index, filterKey, val)}
              onSelectAll={(val) => {
                const newVal = dataList;
                filterChangeFunc(index, filterKey, newVal);
              }}
              data={dataList}
              value={e.filterIndex}
              style={{ width: '24%'}}
              search={true}
            />
          );
        })}

      </ProgressionWrapper>

      <TableContainerWrapper className='tableWrapper'>
        {data?.length === 0 && (
          <Table>
            <TableRow>
              <TableCell>No data found!!</TableCell>
            </TableRow>
          </Table>
        )}
        {/* {!isPPTModalActive && data?.length > 0 && (
          <Table>
            <TableHead className='thead-dark table-sorting'>
              <TableRow className='pptListHeader'>
                <TableCell className='colHeading' onClick={() => onSortByChange('topic')}>
                  {settings.tabRowTitle} <ShowArrow sortGridBy={sortGridBy} columnKey='topic' />
                </TableCell>
                {Array.from({ length: settings.defaultColumnLength }, (_, index) => {
                  const i = 'column' + (index + 1)
                  return (
                    <React.Fragment key={i}>
                      {settings.columns[i].show && settings.columns[i].customColumnSortBy && (
                        <TableCell onClick={() => onSortByChange(i)}>
                          {settings.columns[i].title}{' '}
                          <ShowArrow sortGridBy={sortGridBy} columnKey={i} />
                        </TableCell>
                      )}
                      {settings.columns[i].show && !settings.columns[i].customColumnSortBy && (
                        <TableCell style={{ cursor: 'default' }}>
                          {settings.columns[i].title}
                        </TableCell>
                      )}
                    </React.Fragment>
                  )
                })}
                {showAdminButtons && !isPPTModalActive && (
                  <TableCell className='colAction'></TableCell>
                )}
              </TableRow>
            </TableHead>
          </Table>
        )} */}

        {data?.length > 0 && (
          <Table>
            {/* {isPPTModalActive && ( */}
            <TableHead className='thead-dark table-sorting th-border'>
              <TableRow className='pptListHeader'>
                <TableCell style={{ width: `${settings.tableRowCustomColumnPercentSize}%` }} className='colHeading' onClick={() => onSortByChange('topic')}>
                  {settings.tabRowTitle} <ShowArrow sortGridBy={sortGridBy} columnKey='topic' />
                </TableCell>
                {Array.from({ length: settings.defaultColumnLength }, (_, index) => {
                  const i = 'column' + (index + 1)
                  return (
                    <React.Fragment key={i}>
                      {settings.columns[i].show && settings.columns[i].customColumnSortBy && (
                        <TableCell style={{ width: `${settings.columns[i].CustomColumnPercentSize}%` }} onClick={() => onSortByChange(i)}>
                          {settings.columns[i].title}{' '}
                          <ShowArrow sortGridBy={sortGridBy} columnKey={i} />
                        </TableCell>
                      )}
                      {settings.columns[i].show && !settings.columns[i].customColumnSortBy && (
                        <TableCell style={{ cursor: 'default', width: `${settings.columns[i].CustomColumnPercentSize}%` }}>
                          {settings.columns[i].title}
                        </TableCell>
                      )}
                    </React.Fragment>
                  )
                })}
                {showAdminButtons && !isPPTModalActive && (
                  <TableCell className='colAction'></TableCell>
                )}
              </TableRow>
            </TableHead>
            {/* )} */}
            <TableBody>
              {data.map((dataProps, index) => {
                const { topic, topic_rowSpan, search_showRow } = dataProps
                if (search_showRow === false) return false
                return (
                  <TableRow key={index}>
                    {isPPTModalActive ? (
                      <TableCell dangerouslySetInnerHTML={{ __html: topic }}></TableCell>
                    ) : (
                      <>
                        {topic_rowSpan === 0 ? (
                          <></>
                        ) : topic_rowSpan > 0 ? (
                          <TableCell
                            rowSpan={topic_rowSpan}
                            dangerouslySetInnerHTML={{ __html: topic }}
                          ></TableCell>
                        ) : (
                          <TableCell dangerouslySetInnerHTML={{ __html: topic }}></TableCell>
                        )}
                      </>
                    )}

                    {Array.from({ length: settings.defaultColumnLength }, (_, index) => {
                      const i = 'column' + (index + 1)
                      const isNumber = `column${index + 1}_type` === 'number'
                      const dataValue = isPPTModalActive
                        ? removeUnwantedTagsAndAttributes(dataProps[i])
                        : dataProps[i]
                      // console.log('isNumber = ', isNumber, dataValue)
                      return (
                        <React.Fragment key={i}>
                          {settings.columns[i].show &&
                            (dataValue?.length > 0 ? (
                              <TableCell
                                dangerouslySetInnerHTML={{ __html: dataValue }}
                              ></TableCell>
                            ) : (
                              <TableCell></TableCell>
                            ))}
                        </React.Fragment>
                      )
                    })}
                    {showAdminButtons && !isPPTModalActive && (
                      <TableCell className='colAction'>
                        <IconButton aria-label='Edit' onClick={() => editClicked(dataProps)}>
                          <IconEdit />
                        </IconButton>
                        <IconButton
                          aria-label='Delete'
                          onClick={() => setDeleteBox({ show: true, data: dataProps })}
                        >
                          <IconDelete />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        )}

        {deleteBox.show && (
          <Confirmation
            open={true}
            title={`Are you sure you want to delete this row?`}
            onCancel={() => onCloseBox()}
            // cancelMsg={'Cancel'}
            onSubmit={() => onSubmitBox(deleteBox)}
            // submitMsg={'Yes'}
            // showSubmitMsg={false}
          />
        )}
        {!deleteBox.show && deleteBox.data && <LoaderWrapper />}
      </TableContainerWrapper>
    </>
  )
}

export default GridTable

const ShowArrow = (props) => {
  const { sortGridBy, columnKey } = props
  const { isPPTModalActive } = useGlobalStore()
  if (isPPTModalActive) return <></>
  return (
    <>
      {sortGridBy.key === columnKey && (
        <>{sortGridBy.direction ? <IconSortDownUpArrow /> : <IconSortUpDownArrow />}</>
      )}
    </>
  )
}